import React from 'react';

import { getActiveStation } from '../../store/selectors/getActiveStation';
import { useAppSelector } from '../hooks';
import { ScheduleStationPartsAndBundleViewDialog } from './ScheduleStationPartsAndBundleViewDialog';
import { StationPartsDialog } from './StationPartsDialog';

export function PartsDialog() {
  const activeStation = useAppSelector(getActiveStation);

  if (activeStation == null) {
    return null;
  }

  return activeStation.followsSchedule ? <ScheduleStationPartsAndBundleViewDialog /> : <StationPartsDialog />;
}
